import * as React from 'react';
import { Highlight, themes } from 'prism-react-renderer';
import styled, { css } from 'styled-components';

const pre = styled.pre`
  padding: 10px;
`;

function CodeBlock(editorProps) {
  return (
    // Code pulled from prism-react-renderer's usage example: https://github.com/FormidableLabs/prism-react-renderer?tab=readme-ov-file#usage
    <Highlight
      // Eventually we can create a custom Sleuth theme: https://github.com/FormidableLabs/prism-react-renderer?tab=readme-ov-file#theming
      theme={themes.jettwaveLight}
      code={editorProps.code} //code and language are props that we get from the sanity/code-input plugin
      language={editorProps.language}
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre style={{ ...style, padding: '10px' }}>
          {tokens.map((line, i) => (
            <div key={i} {...getLineProps({ line })}>
              {line.map((token, key) => (
                <span key={key} {...getTokenProps({ token })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
}

export default CodeBlock;
